export default __webpack_public_path__ + "static/media/image_14.2fcf142c.png";